<template>
  <div id="app">
    <SWNewVersion />
    <img class="logo" src="@/assets/logo.svg" alt="binôme" />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import SWNewVersion from '@/components/SWNewVersion.vue'
</script>

<style lang="scss">
@use '@/styles/app';

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

img.logo {
  margin-top: 0.5rem;
  flex-shrink: 0;
}
</style>
